module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.10.1-220.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.10.1.md
// module id = 661
// module chunks = 333